<ng-container *ngIf="showManualMessage; else list_template">
    <span style="margin: 8px; height: 28px; display: flex; justify-content: center;"><b>Viewing manually uploaded annotated file.</b></span>
</ng-container>
<ng-template #list_template>
    <div *ngFor="let page of pageAnnotationMap; trackBy: trackByPageNumber">
        <lex-doc-viewer-coding-section panelId="expandable-annotation-panel-page-{{page.pageNum}}" class="expander">
			<div coding-section-title
                style="min-height: 36px; min-height: 36px; align-items: center; display: flex; width:100%">
                <div style="display:flex; justify-content: space-between; width:100%;">
                    <div>Page {{page.pageNum}}</div>
                    <div style="margin-right: 10px;">{{getActiveAnnotationCount(page.annotations)}}</div>
                </div>
            </div>
            <div *ngFor="let annotation of page.annotations; trackBy: trackById"
                [ngClass]="{'selected-edit': currentAnnotationId === annotation.clientId}"
                style="padding: 8px; display:flex;" class="edit">
                <div (mouseenter)="setSelectedAnnotationId(annotation.clientId)" class="annotation-wrapper">
                    <div *ngIf="annotation.clientId !== editItemTextId"
                        style="width: 75%; height: 100%; margin-left: 6px; display: flex; align-items:center;">
                        <div (click)="setAnnotationEditTextId(annotation);" class="annotation-text">
                            <div *ngIf="annotation.text">
                                {{annotation.text}}
                            </div>
                            <div *ngIf="!annotation.text" matTooltip="Click to add text.">
                                <i class="fa-duotone fa-highlighter-line icon"></i>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="annotation.clientId === editItemTextId"
                        style="display: flex; gap: 8px; width: 100%; align-items: center;">
                        <textarea placeholder="Text" [(ngModel)]="annotation.text" style="width: 100%;" (keyup.enter)="setAnnotationText(annotation, $event)" ></textarea>
                        <div style="cursor: pointer;" (click)="setAnnotationText(annotation)">
                            <i class="fa-duotone fa-check icon-alternate"></i>
                        </div>
                        <div (click)="cancelTextEdit(annotation)" style="cursor: pointer;">
                            <i class="fa-duotone fa-ban icon-alternate"></i>
                        </div>
                    </div>
                    <div *ngIf="annotation.clientId !== editItemTextId"
                        style="display: flex; align-items: center; gap: 20px; margin-right: 16px;">
                        <div style="cursor: pointer;" (click)="editItemColorId = annotation.clientId"
                            [matMenuTriggerFor]="colorMenu">
                            <i class="fa-solid fa-circle" [style.color]="getBackGroundColor(annotation.highlightColor)"
                                style="font-size: 24px;border-radius: 50%; border: 1px solid lightgrey;"></i>
                        </div>
                        <mat-menu #colorMenu="matMenu">
                            <button mat-menu-item *ngFor="let color of annotationColors" style="width: 100%;" (click)="setColor(color, annotation)">
                                <i class="fa-solid fa-circle" style="font-size: 24px; width: 100%; text-align: center;"
                                    [style.color]="getBackGroundColor(color.colorValue)"></i>
                            </button>
                        </mat-menu>
                        <div *ngIf="currentAnnotationId === annotation.clientId" style="cursor: pointer;"
                            (click)="deleteAnnotation(annotation);" matTooltip="Delete">
                            <i class="fa-solid fa-xmark icon-alternate"></i>
                        </div>
                        <div *ngIf="currentAnnotationId !== annotation.clientId" style="min-width: 11px;"></div>
                    </div>
                </div>
            </div>
        </lex-doc-viewer-coding-section>
    </div>
</ng-template>
